import React, { PropTypes } from 'react';
import DataService from '../lib/DataService';
import CurrentRoleActions from '../actions/CurrentRoleActions'
import CurrentRoleStore from '../stores/CurrentRoleStore';
import { hashHistory, Link } from 'react-router';

import { Icon } from 'antd';

export default class NavigationTopBar extends React.Component {
  static propTypes = {
    // name: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);
    // set state
    this.state = {
      currentRole: CurrentRoleStore.getCurrentRole(),
      fullName: '',
      roleName: '',
      avatarUrl: null,

      isLogingOut: false,
    };
    // bind this
    this.onCurrentRoleChange = this.onCurrentRoleChange.bind(this);
    this.loadAvatarUrl = this.loadAvatarUrl.bind(this);
    this.switchRole = this.switchRole.bind(this);
    this.userEdit = this.userEdit.bind(this);
    this.onLogout = this.onLogout.bind(this);
  }

  componentDidMount() {
    CurrentRoleStore.addChangeListener(this.onCurrentRoleChange);
    let currentRole = this.state.currentRole;
    if (currentRole) {
      let role = currentRole.associatName;
      this.setState({
        fullName: role == "student" ? (currentRole.fullName + ' 家长') : (currentRole.fullName + ' 老师'),
        roleName: role == "student" ? currentRole.associatObj.fullName : (role == "classRecord" ? currentRole.associatObj.className : (role == "classGrade" ? currentRole.associatObj.gradename : "全校管理"))
      });
      // get avatar url
      this.loadAvatarUrl(currentRole);
    }
  }

  componentWillUnmount() {
      CurrentRoleStore.removeChangeListener(this.onCurrentRoleChange);
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      currentRole: CurrentRoleStore.getCurrentRole(),
    })
  }

  onCurrentRoleChange() {
    let currentRole = CurrentRoleStore.getCurrentRole();
    if (currentRole)
      this.loadAvatarUrl(currentRole);
    this.setState({
      currentRole: currentRole,
    })
  }

  loadAvatarUrl(currentRole) {
    DataService.getUserInfo().then((response) => {
      let avatarUrl = null;
      if (currentRole.roleName == "teacher")
        avatarUrl = response.teacher_record.avatar_url;
      else
        avatarUrl = response.parent_record.avatar_url;
      this.setState({
        avatarUrl: avatarUrl
      })
    }, (error) => {});
  }

  switchRole() {
    CurrentRoleActions.deleteCurrentUserRole();
    hashHistory.push("/")
  }

  userEdit() {
    //用户操作
    console.log("aa");
  }

  onLogout() {
    this.setState({isLogingOut: true});
    DataService.userLogout().then((response) => {
      document.location = "/web_login";
    }, (error) => {});
  }

  render() {
    let currentRole = this.state.currentRole;
    if (currentRole) {
      let role = currentRole.associatName;
      return (
        <div className="navigation-top-bar">
          <div className="navigation-school-icon"></div>
          <div className="navigation-school-name">{currentRole.associatObj?currentRole.associatObj.schoolName:''}</div>
          <div className="navigation-role-name">{role == "student" ? currentRole.associatObj.fullName : (role == "classRecord" ? currentRole.associatObj.className : (role == "classGrade" ? currentRole.associatObj.gradename : (role == "school" ? "全校管理" : "系统管理员")))}</div>
          <div className="navigation-switch" onClick={this.switchRole}>切换</div>
          <div className="navigation-user">
            {this.state.avatarUrl && <img src={this.state.avatarUrl} className="navigation-user-avatar" />}
            {!this.state.avatarUrl && <div className="navigation-user-avatar default-avatar"></div>}
            <div className="navigation-user-name">{role == "student" ? (currentRole.fullName + (currentRole.fullName.indexOf('家长') < 0 ? ' 家长' : '')) : (currentRole.fullName + (currentRole.fullName.indexOf('老师') < 0 ? ' 老师' : ''))}</div>
            <div className="menu-container">
              <div className="menu">
                <div className="item" style={{display: 'none'}} onClick={this.userEdit}>设置</div>
                <div className="item" onClick={this.onLogout}>登出
                  {this.state.isLogingOut && <Icon type="loading" />}
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
    else
      return (
        <div className="navigation-top-bar">
          <div className="navigation-user logout-btn" onClick={this.onLogout}>
            <div className="navigation-user-name">登出</div>
          </div>
        </div>
      )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/NavigationTopBar.jsx